import type { Application } from '@hotwired/stimulus';
import { Controller } from '@hotwired/stimulus';

export class SiteHeaderAltController extends Controller<HTMLElement> {
    declare readonly overlayNavigationTarget: HTMLDialogElement;
    declare readonly hasOverlayNavigationTarget: boolean;

    static targets = ['overlayNavigation'];

    static register(application: Application) {
        application.register('site-header-alt', this);
    }

    disconnect() {
        this.closeSideMenu();
    }

    openSideMenu() {
        this.overlayNavigationTarget.showModal();
        document.documentElement.style.overflow = 'hidden';
    }

    closeSideMenu() {
        this.overlayNavigationTarget.close();
        document.documentElement.style.overflow = '';
    }
}
